import configs from "@/../app.config.json";
let TITTLE = ""
switch (process.env.NODE_ENV) {
    case 'development':
        TITTLE = configs.otimizacaoHomolog.titulo;
        break;
    case 'preproduction':
        TITTLE = configs.otimizacaoPreProd.titulo;
        break;
    case 'production': 
    default     :
        TITTLE = configs.otimizacaoProd.titulo;
        break;
}
let prefix = "/";

const linksAntigosApp = [
    "hubperfil/pedidos",
    "tickets/:idapresentacao",
    "hubperfil",
    "hubperfil/financeiro",
    "sersocioendereco",
];
const linksOlds = [];

linksAntigosApp.forEach((item, index) => {
    linksOlds.push({
        path: prefix + item,
        name: 'Update' + index,
        props: true,
        params: true,
        redirect: prefix + 'update',
    })
})

export default [
    {
        path: '*',
        name: 'Error',
        component: () => import(/* webpackChunkName: "error" */ '@/views/Error.vue'),
        meta: { title: TITTLE + 'Error 404', requiresAuth: false }
    },
    {
        path: prefix + 'sinconexion',
        name: 'SemConexao',
        component: () => import(/* webpackChunkName: "semconexao" */ '@/views/Sem-conexao.vue'),
        meta: { title: TITTLE + 'Sem Conexão', requiresAuth: false }
    },
    {
        path: prefix + "politicas/privacidade",
        name: "Politics",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "login" */ "@/views/politicas/Politics.vue"
            ),
        meta: {
            title: TITTLE + "Política de Privacidade",
            requiresAuth: false,
        },
    },
    {
        path: prefix + "politicas/cookies",
        name: "PoliticsCookies",
        props: true,
        params: true,
        component: () =>
            import(
                /* webpackChunkName: "login" */ "@/views/politicas/Politics.vue"
            ),
        meta: {
            title: TITTLE + "Política de Privacidade",
            requiresAuth: false,
        },
    },
    {
        path: prefix + '/',
        name: 'Login',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "login" */ '@/views/onboarding/Login.vue'),
        meta: { title: TITTLE + 'Login', requiresAuth: false }
    },
    {
        path: prefix + 'olividelacontrasena',
        name: 'Esquecisenha',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "esqueciSenha" */ '@/views/onboarding/Forgot-password.vue'),
        meta: { title: TITTLE + 'Olivdé la Contraseña', requiresAuth: false }
    },
    {
        path: prefix + 'nuevacontrasena',
        name: 'NovaSenha',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "NovaSenha" */ '@/views/Nova-senha.vue'),
        meta: { title: TITTLE + 'Nueva Contraseña', requiresAuth: false }
    },
    {
        path: prefix + 'registro/:tipo',
        name: 'Cadastro',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "cadastro" */ '@/views/onboarding/Signin.vue'),
        meta: { title: TITTLE + 'Registro', requiresAuth: false }
    },
    {
        path: prefix + 'extranjero',
        name: 'CadastroEstrangeiro',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "cadastro" */ '@/views/onboarding/Foreigner.vue'),
        meta: { title: TITTLE + 'Registro Extranjero', requiresAuth: false }
    },
    {
        path: prefix + 'hub',
        name: 'Hub',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "hub" */ '@/views/Hub.vue'),
        meta: { title: TITTLE + 'Hub Torcedor', requiresAuth: true }
    },
    {
        path: prefix + 'perfil',
        name: 'Perfil',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "perfil" */ '@/views/profile/Home.vue'),
        meta: { title: TITTLE + 'Hub Perfil', requiresAuth: true }
    },
    {
        path: prefix + 'perfil/dado',
        name: 'HubDados',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "perfil/dados" */ '@/views/profile/Dados.vue'),
        meta: { title: TITTLE + 'Hub Dado', requiresAuth: true }
    },
    {
        path: prefix + 'perfil/direccion',
        name: 'HubEndereco',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "perfil/endereco" */ '@/views/profile/Address.vue'),
        meta: { title: TITTLE + 'Hub Direccion', requiresAuth: true }
    },
    {
        path: prefix + 'perfil/peticiones',
        name: 'HubPedidos',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "perfil/address" */ '@/views/profile/Pedidos-abertos.vue'),
        meta: { title: TITTLE + 'Hub Peticiones', requiresAuth: true }
    },
    {
        path: prefix + 'perfil/peticionesterminados',
        name: 'HubPedidosFinalizados',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "perfil/address" */ '@/views/profile/Pedidos-finalizados.vue'),
        meta: { title: TITTLE + 'Hub Peticiones Terminados', requiresAuth: true }
    },
    {
        path: prefix + 'juegos',
        name: 'Jogos',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "perfil/jogos" */ '@/views/Matchs.vue'),
        meta: { title: TITTLE + 'Hub Juegos', requiresAuth: true }
    },
    {
        path: prefix + 'jogosquejafui',
        name: 'jogosjafui',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "jogosjafui" */ '@/views/Past-matchs.vue'),
        meta: { title: TITTLE + 'Jogos que ja Fui', requiresAuth: true }
    },
    {
        path: prefix + 'perfil/financiero',
        name: 'HubFinanceiro',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "perfil/financeiro" */ '@/views/profile/Financeiro-prox.vue'),
        meta: { title: TITTLE + 'Hub Financiero', requiresAuth: true }
    },
    {
        path: prefix + 'perfil/financieropagado',
        name: 'HubFinanceiroPago',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "perfil/financeiropago" */ '@/views/profile/Financeiro-pago.vue'),
        meta: { title: TITTLE + 'Hub Financiero Pagado', requiresAuth: true }
    },
    {
        path: prefix + 'perfil/financierotarjeta',
        name: 'HubFinanceiroCartao',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "perfil/financeirocartao" */ '@/views/profile/Financeiro-cartao.vue'),
        meta: { title: TITTLE + 'Hub Financiero Tarjeta', requiresAuth: true }
    },
    {
        path: prefix + 'planes',
        name: 'Planos',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "entrar" */ '@/views/Plans.vue'),
        meta: { title: TITTLE + 'Planes', requiresAuth: true },
        children: [{
            path: 'p/:plano',
            name: 'PlanosSegmentado',
        }]
    },
    {
        path: prefix + 'planessilla',
        name: 'PlanosCadeira',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "entrar" */ '@/views/Planos.vue'),
        meta: { title: TITTLE + 'Planes silla', requiresAuth: true }
    },
    // {
    //     path: prefix + 'enviardocumentos',
    //     name: 'EnviarDoc',
    //     props: true,
    //     params: true,
    //     component: () => import(/* webpackChunkName: "enviardocumentos" */ '@/views/Sersocio.vue'),
    //     meta: { title: TITTLE + 'Enviar Documentos', requiresAuth: true }
    // },
    {
        path: prefix + 'sermiembroacademia',
        name: 'SerSocioAcademia',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "sermiembroacademia" */ '@/views/checkout-member/Success-Academia.vue'),
        meta: { title: TITTLE + 'Ser Miembro Academia', requiresAuth: true }
    },
    {
        path: prefix + 'serunadirecciondemiembro',
        name: 'SerSocioEndereco',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "sersocioendereco" */ '@/views/checkout-member/Address.vue'),
        meta: { title: TITTLE + 'Ser una Direccion de Miembro', requiresAuth: true }
    },
    {
        path: prefix + 'seaunsociodepago',
        name: 'SerSocioPagamento',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "sersociopagamento" */ '@/views/checkout-member/Payment.vue'),
        meta: { title: TITTLE + 'Sea un Socio Pagmento', requiresAuth: true }
    },
    {
        path: prefix + 'seaunsocioactivación',
        name: 'SerSocioAtivacao',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "sersocioativacao" */ '@/views/checkout-member/Activation.vue'),
        meta: { title: TITTLE + 'Sea un Socio Activación', requiresAuth: true }
    },
    {
        path: prefix + 'seaunsociocheckout',
        name: 'SerSocioCheckout',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "sersociocheckout" */ '@/views/Sersocio.vue'),
        meta: { title: TITTLE + 'Sea un Socio Checkout', requiresAuth: true }
    },
    {
        path: prefix + 'tickets/:pagina',
        name: 'PaginaTickets',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "tickets" */ '@/views/Match.vue'),
        meta: { title: TITTLE + 'Tickets', requiresAuth: true }
    },
    {
        path: prefix + 'ticketssilla/:pagina',
        name: 'TicketsCadeira',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "ticketscadeira/:pagina" */ '@/views/Comprar-tickets.vue'),
        meta: { title: TITTLE + 'Tickets Silla', requiresAuth: true }
    },
    {
        path: prefix + 'ticketsinformacion/:pagina',
        name: 'TicketsInformacao',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "ticketsinformacao/:pagina" */ '@/views/Comprar-tickets.vue'),
        meta: { title: TITTLE + 'Tickets informação', requiresAuth: true }
    },
    {
        path: prefix + 'ticketscheckout/:pagina',
        name: 'TicketsCheckout',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "ticketscheckout/:pagina" */ '@/views/Comprar-tickets.vue'),
        meta: { title: TITTLE + 'Checkout', requiresAuth: true }
    },
    
    {
        path: prefix + 'carrinho/:pagina',
        name: 'Cart',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "Carrinho" */ '@/views/cart/Cart.vue'),
        meta: { title: TITTLE + 'Carrinho', requiresAuth: true }
    },
    {
        path: prefix + 'carrinho/sucesso/:pagina',
        name: 'CartSuccess',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "Carrinho - Sucesso" */ '@/views/cart/Success.vue'),
        meta: { title: TITTLE + 'Carrinho - Sucesso', requiresAuth: true }
    },

    {
        path: prefix + 'silladealquiler',
        name: 'LocarCadeira',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "locarcadeira" */ '@/views/checkout-seats/Seat.vue'),
        meta: { title: TITTLE + 'Silla de Alquiler', requiresAuth: true }
    },
    {
        path: prefix + 'alquilarsillainformacion',
        name: 'LocarCadeiraInformacao',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "locarcadeirainformacao" */ '@/views/checkout-seats/Confirmation.vue'),
        meta: { title: TITTLE + 'Alquilar Silla Información', requiresAuth: true }
    },
    {
        path: prefix + 'alquilarsillapago',
        name: 'LocarCadeiraPagamento',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "locarcadeirapagamento" */ '@/views/checkout-seats/Payment.vue'),
        meta: { title: TITTLE + 'Alquilar Silla Pago', requiresAuth: true }
    },
    {
        path: prefix + 'locarcadeiraativacao',
        name: 'LocarCadeiraAtivacao',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "locarcadeiraativacao" */ '@/views/Locacao-cadeira.vue'),
        meta: { title: TITTLE + 'Alquilar Silla Activación', requiresAuth: true },
    },
    {
        path: prefix + 'ubicacioncheckout',
        name: 'PagarLocacaoSucesso',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "locacaocheckout" */ '@/views/checkout-seats/Success-seats.vue'),
        meta: { title: TITTLE + 'Ubicación Sucesso', requiresAuth: true }
    },
    {
        path: prefix + 'bienvinida',
        name: 'BoasVindas',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "boasvindas" */ '@/views/boas-vindas.vue'),
        meta: { title: TITTLE + 'Bien vinida', requiresAuth: true }
    },
    {
        path: prefix + 'webmail/view/:idmail',
        name: 'Webmail',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "Webmail" */ '@/views/ViewEmails.vue'),
        meta: { title: TITTLE + 'Webmail', requiresAuth: false }
    }, 
    {
        path: prefix + 'en-vivo',
        name: 'Live',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "Carrinho" */ '@/views/Live.vue'),
        meta: { title: TITTLE + 'En vivo', requiresAuth: true }
    },
    {
        path: prefix + 'help',
        name: 'Help',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "Carrinho" */ '@/views/help/Help.vue'),
        meta: { title: TITTLE + 'Help', requiresAuth: true }
    },
    {
        path: prefix + 'design-system',
        name: 'DesignSystem',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "DesignSystem" */ '@/views/DesignSystem.vue'),
        meta: { title: TITTLE + 'Design System', requiresAuth: true }
    },
    {
        path: prefix + 'app',
        name: 'App',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "Webmail" */ '@/views/App.vue'),
        meta: { title: TITTLE + 'Aplicativo Mundo Colorado', requiresAuth: false }
    },
    {
        path: prefix + 'landpage/:pagina',
        name: 'Landpage',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "Webmail" */ '@/views/Landingpage.vue'),
        meta: { title: TITTLE + 'Landpage', requiresAuth: true }
    },
    {
        path: prefix + 'noite-gigante',
        name: 'NoiteGigante',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "Webmail" */ '@/views/Noite-gigante.vue'),
        meta: { title: TITTLE + 'Landpage', requiresAuth: true }
    },
    {
        path: prefix + 'noite-gigante-ingressos',
        name: 'NoiteGiganteIngressos',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "Webmail" */ '@/views/Noite-gigante-ingressos.vue'),
        meta: { title: TITTLE + 'Landpage', requiresAuth: true }
    },
    {
        path: prefix + 'voucher',
        name: 'Voucher',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "Webmail" */ '@/views/Voucher.vue'),
        meta: { title: TITTLE + 'Voucher', requiresAuth: true }
    },

    // Institucionais
    {
        path: prefix + 'beira-rio',
        name: 'BeiraRio',
        props: true,
        params: true,
        component: () => import(/* webpackChunkName: "BeiraRio" */ '@/views/institucionais/Beira-rio.vue'),
        meta: { title: TITTLE + 'Beira-Rio', requiresAuth: false }
    },

    ...linksOlds
]